@if (permDir.uipermission() !== PERMISSIONS.NONE || permDir.editPermissions()) {
  <!-- Input -->
  <table uispreadsheet #uiSpreadSheet>
    <thead>
      <tr>
        <th uispreadsheetheader (click)="clickHeader($event, -1, -1)"></th>
        @for (
          col of settings().columnTitles;
          track col;
          let firstCol = $first;
          let iCol = $index
        ) {
          <th
            uispreadsheetheader
            class="align-center justify-center"
            [class.marked]="shouldBeMarked(iCol, -1)"
            tabindex="0"
            (click)="clickHeader($event, iCol, -1)"
            (keydown.control.c)="copy($event)"
          >
            {{ col }}
          </th>
        }
        @if (dataSummary()) {
          <th uispreadsheetsummary>{{ settings().summaryTitle }}</th>
        }
      </tr>
    </thead>
    <tbody #uiValueRef>
      @for (
        row of settings().rowTitles;
        track iRow;
        let iRow = $index;
        let firstRow = $first;
        let lastRow = $last
      ) {
        <tr>
          <td
            uispreadsheetheader
            class="align-center justify-center"
            [class.marked]="shouldBeMarked(-1, iRow)"
            (click)="clickHeader($event, -1, iRow)"
          >
            {{ row }}
          </td>

          @for (
            col of settings().columnTitles;
            track iCol;
            let iCol = $index;
            let firstCol = $first;
            let lastRow = $last
          ) {
            @let cell = (cells()! | getByRowCol: iCol : iRow)!;
            @if (cell) {
              <td
                uispreadsheetcell
                #uiSpreadSheetCell
                [attr.uiTag]="cell.tag"
                [attr.uiState]="cell.state?.()"
                [attr.uidisabled]="
                  cell.dataItem?.[settings().disabledField!] ? '' : undefined
                "
                [attr.UiAnnotation]="cell.annotations"
                tabIndex="1"
                [attr.data-index]="indexFromColumnRow(iCol, iRow)"
                [attr.draggable]="true"
                [class.selected]="cell.selected"
                [class.editing]="cell.editing"
                [class.marked]="cell.marked"
                [class.deleted]="
                  cell.dataItem?.[settings().deletedField!] && !cell.editing
                "
                [class]="
                  cell.classes() +
                  ' ' +
                  (settings().conditionalFormatting?.(cell.dataItem) ?? '')
                "
                [attr.title]="cell.annotations"
                (keydown)="keydown($event, cell)"
                (click)="click($event, cell)"
                (dblclick)="editCell(cell)"
                (dragstart)="startDrag($event, cell)"
                (dragenter)="enterDrag(cell)"
                (dragend)="endDrag()"
                (paste)="paste($event)"
              >
                @if (
                  cell.editing && permDir.uipermission() !== PERMISSIONS.VIEW
                ) {
                  <input
                    #input
                    uiinput
                    uispreadsheetcellinput
                    #uiSpreadSheetCellinput
                    type="text"
                    [(value)]="cell.dataItem![settings().valueField!]"
                    (keydown)="keydown($event, cell); $event.stopPropagation()"
                    (click)="$event.stopPropagation()"
                    (focusout)="commitEdit(uiSpreadSheetCellinput.value, cell)"
                  />
                }

                {{ !cell.editing ? cell.formattedValue() : null }}
              </td>
            }
          }

          @if (dataSummary()) {
            @let summaryCell = summaryCells()![iRow];
            <td
              uispreadsheetsummary
              [class]="
                summaryCell.classes() +
                ' ' +
                (settings().conditionalFormatting?.(summaryCell.dataItem) ?? '')
              "
            >
              {{ summaryCell?.formattedValue() }}
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
}
